import {DataStatus} from 'platform/components';

import {isNotNil} from 'ramda';
import {isTrue} from 'ramda-adjunct';

import {
  useAccGetConfigurationExportAbraQuery,
  useAccPatchConfigurationExportAbraMutation,
} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems, SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {buildArray} from 'shared/web';

export function AccountingIntegrations() {
  const {data: abraConfig, isLoading, isError} = useAccGetConfigurationExportAbraQuery();
  const [patchAbraConfig] = useAccPatchConfigurationExportAbraMutation();

  const isAbraConfigured =
    isNotNil(abraConfig?.abraAccount?.value) &&
    isNotNil(abraConfig?.abraCompany?.value) &&
    isNotNil(abraConfig?.mappingMethod?.id) &&
    isNotNil(abraConfig?.abraCredentials?.username) &&
    isNotNil(abraConfig?.abraCredentials?.password);

  const handleAbraSwitchChange = (enabled: boolean) => {
    patchAbraConfig({disable: !enabled}).unwrap().catch(handleApiError);
  };

  const items = buildArray<SettingsStackItemProps>([
    {
      cyId: testIds.settings.accountingIntegrationsAbra('link'),
      title: i18n.t('page.accountingSettings.labels.abraFlexi'),
      url: settingsRoutes.accountingIntegrationsAbra,
      switchProps: {
        name: 'accounting-integrations-abra',
        value: isTrue(abraConfig?.isEnabled),
        onChange: handleAbraSwitchChange,
        isDisabled: !isAbraConfigured,
      },
    },
    {
      cyId: testIds.settings.exportParameters('link'),
      title: i18n.t('page.accountingSettings.labels.exportParameters'),
      url: settingsRoutes.exportParameters,
    },
  ]);

  return (
    <SettingsTemplate
      header={{title: i18n.t('page.accountingSettings.labels.integrations')}}
      data-testid={testIds.settings.accountingIntegrations('settings-template')}
    >
      <DataStatus isLoading={isLoading} isError={isError} minHeight={20}>
        <SettingsStackItems items={items} />
      </DataStatus>
    </SettingsTemplate>
  );
}
